"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var UnstyledButton = function UnstyledButton(props) {
  return _react.default.createElement(_UIButton.default, Object.assign({
    use: "unstyled"
  }, props));
};

var _default = (0, _styledComponents.default)(UnstyledButton).withConfig({
  displayName: "StyleProtectedSelectItem",
  componentId: "sc-1r4010v-0"
})(["color:", " !important;background-color:", " !important;.is-focused > &{background-color:", " !important;}"], _colors.OBSIDIAN, _colors.OLAF, _colors.CALYPSO_LIGHT);

exports.default = _default;
module.exports = exports.default;